import React from "react";
import QuestionRenderLatex from "../../atoms/QuestionRenderLatex/QuestionRenderLatex";
import {Nullable} from "../../../../../@typings/typings";

interface QuestionRenderSolutionProps {
    solution: Nullable<string>;
}

export default function QuestionRenderSolution({ solution }: QuestionRenderSolutionProps) {
    return <QuestionRenderLatex title={"Решение"} renderString={solution} />
}